module.exports = __webpack_public_path__ + "static/media/waterFilterQuestion.79670e5f.png";